import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { getProductKeyFromCTType } from '@grandvisionhq/utils';
import { productDetailContextReducer, initialState } from './reducer.js';

/**
 * Product Context
 */ const ProductContext = /*#__PURE__*/ React.createContext({});
ProductContext.displayName = 'ProductContext';
const useProductData = ()=>{
    const context = React.useContext(ProductContext);
    if (!context) {
        throw new Error(`No ${ProductContext.displayName} available. You might need to add the ${ProductContext.displayName} provider component.`);
    }
    return context;
};
/**
 * Product Provider
 */ const ProductProvider = ({ children , sku , selfUrl , product , specificationConfiguration , routes , colorFeatureIcons , bookAppointmentRouteConfig ,  })=>{
    const { variants  } = product;
    const [state, dispatch] = React.useReducer(productDetailContextReducer, swcHelpers.objectSpread({}, initialState, {
        activeSku: sku
    }));
    const activeVariant = React.useMemo(()=>variants.find((variant)=>variant.sku === state.activeSku
        ) || variants[0]
    , [
        state,
        variants
    ]);
    const productLink = useLink({
        route: 'products.detail',
        params: {
            slug: activeVariant.slug,
            sku: activeVariant.sku,
            key: getProductKeyFromCTType(product.productType)
        }
    });
    const productUrl = `${selfUrl}${productLink === null || productLink === void 0 ? void 0 : productLink.href}`;
    const value = {
        activeVariant,
        dispatch,
        productUrl,
        product,
        specificationConfiguration,
        routes,
        colorFeatureIcons,
        bookAppointmentRouteConfig
    };
    return /*#__PURE__*/ React.createElement(ProductContext.Provider, {
        value: value
    }, children);
};

export { ProductContext, ProductProvider, useProductData };
//# sourceMappingURL=ProductContext.js.map
